import { ModalType } from './ModalType';

export enum ModalTypeClass {
  "modal-error" = ModalType.Error,
  "modal-warning" = ModalType.Warning,
  "modal-info" = ModalType.Info,
  "modal-default" = ModalType.Default
}
